import { isUndefined } from "../../../utils";

const positionStyle = (position: {
	position?: string;
	top?: number;
	right?: number;
	bottom?: number;
	left?: number;
}) => {
	let style = "";
	if (!position?.position || "none" === position.position) {
		return style;
	}
	style += `position: ${position.position};`;
	for (const side of ["top", "right", "bottom", "left"]) {
		const sideVal = position?.[side] ?? undefined;
		if (!isUndefined(sideVal)) {
			style += `${side}: ${sideVal}px;`;
		}
	}
	return style;
};

export default positionStyle;
